import css from '@/components/ui/shared/Table/cells/ProfileCell.module.css';
import ProfileLink from '@/scenes/Management/Community/ProfileLink';
import type { ReactNode } from 'react';

export interface ProfileLike {
  id: string;
  nickname?: string;
  settings?: unknown;
}

interface Props {
  profile: ProfileLike;
  /** Overrides the default /profile/{id} link target. */
  link?: string;
  /** Optional second line under the nickname, e.g. a blog title. */
  secondary?: ReactNode;
}

export function ProfileCell({ profile, link, secondary }: Props) {
  return (
    <ProfileLink profile={profile} link={link}>
      {secondary != null && <span className={css.secondary}>{secondary}</span>}
    </ProfileLink>
  );
}
